module.exports = __webpack_public_path__ + "static/media/utedo.c17f8542.svg";